import ApiGatewayFunction from "../../UserConfigs/ApiGatewayFunction.js";

/** Reverts an approved (not yet exported) asset back to draft. */
export async function revertToDraft(appConfig, { brandId, assetId }, setIsLoading, setApiResponse) {
  const payload = {
    request_type: "studio/create_asset",
    request_sub_type: "set_asset_status",
    client_id: appConfig.clientId,
    brand_id: brandId,
    asset_id: assetId,
    status: "draft",
  };

  const response = await ApiGatewayFunction(
    payload,
    appConfig.patternAPI,
    appConfig.support_key,
    appConfig.support_id,
    setIsLoading,
    setApiResponse,
    appConfig.testingState
  );

  const asset = response?.data?.asset;
  if (!asset) {
    throw new Error(response?.data?.error || "Couldn't revert this asset to draft");
  }
  return asset;
}